import React from 'react';
import { FormInstance } from 'antd/es/form';
import { AutoCompleteInput } from 'components/base/AutoComplete';
import { moveToFirstError } from 'libs/api/errorHandle';
import { autoCompleteUniversityName, autoCompleteMajorName } from 'libs/api/main';
import { CMonthFormat } from 'constants/base.const';
import { CUserType, CUserTypeColor, CDegreeType } from 'constants/user.const';
import { EUserType, EDegreeType } from 'enums/base.enum';
import { Button, Form, Radio, Divider, Typography, Row, Col, Input, Tag, DatePicker } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { FormWrapper } from 'GlobalStyles';

const { Text, Title } = Typography;
type TEducationProps = {
  userType: EUserType;
  form: FormInstance;
  onClickNext?: () => void;
};
const Education = ({ userType, form, onClickNext }: TEducationProps) => {
  return (
    <FormWrapper style={{ maxWidth: '380px' }}>
      <Form
        name='education'
        form={form}
        layout='vertical'
        initialValues={{ educations: [{ degree_type: EDegreeType.Bachelor }] }}
        className='form-inline'
      >
        <Tag color={CUserTypeColor[userType]}>{CUserType[userType]}</Tag>
        <Title level={2} style={{ marginBottom: '20px' }}>
          <span style={{ color: `${CUserTypeColor[userType]}` }}>학력사항</span>
          을<br />
          입력해주세요
        </Title>
        <Text style={{ display: 'block', marginBottom: '10px' }} strong>
          학력사항
        </Text>
        <Form.List name='educations'>
          {(fields, { add, remove }) => (
            <div>
              {fields.map((field, index) => (
                <Form.Item key={field.key} noStyle={true}>
                  <Form.Item
                    name={[field.name, 'degree_type']}
                    className='form-item form-item-no-label'
                    rules={[{ required: true }]}
                  >
                    <Radio.Group className='col-6'>
                      <Radio.Button value={EDegreeType.Bachelor}>
                        {CDegreeType[EDegreeType.Bachelor]}
                      </Radio.Button>
                      <Radio.Button value={EDegreeType.Master}>
                        {CDegreeType[EDegreeType.Master]}
                      </Radio.Button>
                      <Radio.Button value={EDegreeType.Doctor}>
                        {CDegreeType[EDegreeType.Doctor]}
                      </Radio.Button>
                      <Radio.Button value={EDegreeType.MBA}>{CDegreeType[EDegreeType.MBA]}</Radio.Button>
                    </Radio.Group>
                  </Form.Item>
                  <Form.Item noStyle>
                    <Row>
                      <Col flex='auto'>
                        <Form.Item
                          name={[field.name, 'university_name']}
                          className='form-item'
                          label='학교명'
                          rules={[{ required: true }]}
                        >
                          <AutoCompleteInput
                            promise={autoCompleteUniversityName}
                            form={form}
                            name={[field.name, 'university_name']}
                          >
                            <Input autoComplete='off' size='large' placeholder='학교명을 입력해주세요' />
                          </AutoCompleteInput>
                        </Form.Item>
                      </Col>
                      {fields.length > 1 && (
                        <Col flex='50px'>
                          <div
                            className='list-delete-button'
                            onClick={() => {
                              remove(field.name);
                            }}
                          >
                            <DeleteOutlined />
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Form.Item>
                  <Form.Item
                    name={[field.name, 'major']}
                    className='form-item'
                    label='전공'
                    rules={[{ required: true }]}
                  >
                    <AutoCompleteInput
                      promise={autoCompleteMajorName}
                      form={form}
                      name={[field.name, 'major']}
                    >
                      <Input autoComplete='off' size='large' placeholder='전공을 입력해주세요' />
                    </AutoCompleteInput>
                  </Form.Item>
                  <Form.Item noStyle>
                    <Input.Group>
                      <Row gutter={[8, 8]}>
                        <Col span={12}>
                          <Form.Item
                            name={[field.name, 'date_from']}
                            className='form-item'
                            label='입학년도'
                            rules={[{ required: true }]}
                          >
                            <DatePicker picker='month' format={CMonthFormat} placeholder='입학년도 선택' />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name={[field.name, 'date_to']}
                            className='form-item'
                            label='졸업년도'
                            rules={[{ required: true }]}
                          >
                            <DatePicker
                              picker='month'
                              format={CMonthFormat}
                              placeholder='졸업년도 혹은 예정년도'
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Form.Item>
              ))}
              <Form.Item noStyle={true}>
                <Divider />
                <div className='list-plus-button'>
                  <Button
                    onClick={() => {
                      add({ degree_type: EDegreeType.Bachelor });
                    }}
                  >
                    <PlusOutlined />
                  </Button>
                </div>
              </Form.Item>
            </div>
          )}
        </Form.List>
        <Form.Item shouldUpdate={true} noStyle={true}>
          {() => (
            <div className='steps-action'>
              <Row gutter={[4, 0]}>
                <Col span={24}>
                  <Button
                    type='primary'
                    htmlType='submit'
                    size='large'
                    onClick={() => {
                      form.validateFields().catch((errorInfo) => {
                        moveToFirstError(form, errorInfo.errorFields);
                      });
                    }}
                  >
                    다음
                  </Button>
                </Col>
              </Row>
            </div>
          )}
        </Form.Item>
      </Form>
    </FormWrapper>
  );
};

export default Education;
